export default __webpack_public_path__ + "static/media/Comedor.69ec7ebc.jpeg";